<template>
  <v-card class="nospace sales-list-card oms-list-table-card">
    <span class="note-text"
      >*Note - To duplicate existing inquiry, click recreate inquiry on the
      action column below.
    </span>
    <v-card-text class="nospace sales-list-body">
      <ScrollableTable
        v-if="!workingCountry.includes('PAK')"
        class="sales-table-scroll oms-list-table-scroll"
        min-width="100%"
      >
        <v-data-table
          id="customerListTable"
          class="sales-modern-table sales-modern-table--global oms-list-table"
          hide-actions
          :headers="headers"
          :items="items"
          :disable-initial-sort="true"
          :pagination.sync="pagination"
        >
        <template slot="items" slot-scope="props">
          <td class="sales-job-cell">
            <div class="sales-job-id-row">
              <activityLogs
                class="sales-row-log-button"
                :type="'inquiry'"
                :id="props.item.inquiryId.toString()"
              />
              <span
                :class="['sales-job-id', salesIdSizeClass(props.item.jobId)]"
                :title="props.item.jobId ? props.item.jobId.toString() : '-'"
              >
                {{ props.item.jobId || "-" }}
              </span>
            </div>
          </td>
          <td class="sales-inquiry-id-cell">
            <span
              :class="[
                'sales-inquiry-id',
                salesIdSizeClass(props.item.inquiryId),
              ]"
              :title="props.item.inquiryId.toString()"
            >
              {{ props.item.inquiryId }}
            </span>
          </td>
          <td class="sales-country-cell">
            <div class="sales-country-content">
              <img
                v-if="props.item.workingCountry == 'PAK'"
                src="../../assets/pakflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'KSA'"
                src="../../assets/ksaflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE'"
                src="../../assets/Uaeflag.png"
                height="20px"
              />
              <img
                v-if="props.item.workingCountry == 'UAE LA'"
                src="../../assets/Uaeflag.png"
                height="20px"
                style="border-radius: 50%"
              />
              <img
                v-if="props.item.workingCountry == 'OMAN'"
                src="../../assets/omanflag.png"
                height="28px"
              />
              <span class="sales-country-label">
                {{ props.item.workingCountry || "-" }}
              </span>
            </div>
          </td>
          <td class="sales-job-type-cell">
            {{ getJobTypeWithCount(props.item.jobType) || "Land" }}
          </td>
          <td v-if="props.item.userId" class="sales-customer-cell">
            <div class="sales-customer-stack sales-customer-stack--compact">
              <div
                :class="[
                  'sales-customer-company',
                  salesTextSizeClass(capitalize(props.item.userId.companyName))
                ]"
                :title="capitalize(props.item.userId.companyName) || 'N.A.'"
              >
                {{ capitalize(props.item.userId.companyName) || "N.A." }}
              </div>
              <CustomerDetailPopUp
                :detail="props.item"
                trigger-class="sales-customer-view-btn"
              />
            </div>
          </td>
          <td v-else>NA</td>
          <td v-if="props.item.bookingDate" class="sales-start-date-cell">
            {{ getTime3(props.item.bookingDate) }}
          </td>
          <td v-else class="sales-start-date-cell">NA</td>
          <td>
            <salesAddressPopup :inquiryId="props.item.inquiryId" />
          </td>
          <td class="sales-trucks-cell">
            <span class="sales-trucks-value">
              {{ props.item.numberOfAssignmentsRequired || "N.A" }}
            </span>
          </td>
          <td>{{ props.item.invoiceNumber || "-" }}</td>
          <td>
            {{ $formatPrice(props.item.quotedPrice) }}
            {{ props.item.customerCurrency || "" }} |
            {{ props.item.inquirySource || "N.A." }}
            <!-- {{ props.item.inquirySource || "N.A." }} | <br /><span
              v-if="
                props.item.workingCountry == 'UAE' ||
                props.item.workingCountry == 'KSA'
              "
              >Credit Limit Remain:<span
                v-if="
                  props.item.userId.creditRemaining == 0 ||
                  props.item.userId.creditRemaining < 0
                "
                class="red-text"
                >{{ props.item.userId.creditRemaining }}
                {{ props.item.customerCurrency || "" }}</span
              >
              <span v-else
                >{{ props.item.userId.creditRemaining }}
                {{ props.item.customerCurrency || "" }}</span
              >
            </span> -->

            <br />
            <a v-if="props.item.proof">
              <v-flex v-if="props.item.proof.length">
                <ProofOfDelivery :deliveryProof="props.item.proof" />
              </v-flex>
            </a>
          </td>
          <td v-if="props.item.quoteNeededBy">
            {{ getTime4(props.item.quoteNeededBy) }}
          </td>
          <td v-else>N A</td>

          <td class="sales-status-cell">
            <span
              :class="[
                'sales-status-pill',
                statusClass(props.item.inquiryStatus),
                salesTextSizeClass(props.item.inquiryStatus)
              ]"
            >
              {{ props.item.inquiryStatus || "N.A." }}
            </span>
            <div class="sales-cell-actions sales-cell-actions--status">
              <button
                @click="open(props.item, 'Delay', props.index)"
                v-if="
                  props.item.inquiryStatus == 'Inquiry Received' ||
                  props.item.inquiryStatus == 'Reopen'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn yellow-button oms-btn oms-btn--conditional"
                title="Mark as Delayed"
              >
                Delayed
              </button>

              <button
                @click="open(props.item, 'Lead lost', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit'
                "
                target="_blank"
                :loading="loading"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 red-button oms-btn oms-btn--destructive"
                title="Mark as lead lost"
              >
                Lead Lost
              </button>
            </div>
          </td>
          <td v-if="props.item.jobId" class="sales-assignments-cell">
            <Assignments
              v-permissions="'activity-logs-jobs'"
              :jobId="props.item.jobId"
              :Section="'Sales'"
            />
          </td>
          <td v-else class="sales-assignments-cell"></td>

          <td class="sales-actions-cell">
            <div class="sales-cell-actions">
              <button
                @click="check(props.item.inquiryId)"
                v-if="
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Low Credit Limit'
                "
                target="_blank"
                :disabled="
                  props.item.inquiryStatus == 'Low Credit Limit' || loading
                "
                class="track-ass-btn oms-btn oms-btn--secondary"
                title="Edit Inquiry"
                v-permissions="'edit-enquiry'"
              >
                <v-icon color="red darken-1" flat prepend-icon>create</v-icon>
              </button>

              <button
                @click="open(props.item, 'Customer Rate Accepted', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit' &&
                  props.item.workingCountry == 'KSA'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 green-button oms-btn oms-btn--primary sales-rate-accepted-btn"
                title="Mark as Rate Accepted"
              >
                Customer Rate Accepted
              </button>

              <button
                @click="open(props.item, 'Customer Rate Accepted', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit' &&
                  props.item.inquiryStatus != 'Reopen' &&
                  props.item.workingCountry == 'UAE'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 green-button oms-btn oms-btn--primary sales-rate-accepted-btn"
                title="Mark as Rate Accepted"
              >
                Customer Rate Accepted
              </button>
              <button
                @click="open(props.item, 'Customer Rate Accepted', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit' &&
                  props.item.inquiryStatus != 'Reopen' &&
                  props.item.workingCountry == 'UAE LA'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 green-button oms-btn oms-btn--primary sales-rate-accepted-btn"
                title="Mark as Rate Accepted"
              >
                Customer Rate Accepted
              </button>
              <button
                @click="open(props.item, 'Customer Rate Accepted', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit' &&
                  props.item.inquiryStatus != 'Reopen' &&
                  props.item.workingCountry == 'OMAN'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 green-button oms-btn oms-btn--primary sales-rate-accepted-btn"
                title="Mark as Rate Accepted"
              >
                Customer Rate Accepted
              </button>

              <button
                v-permissions="'add-enquiry'"
                @click="
                  recreateInquiry(props.item.inquiryId, props.item.userId.userId)
                "
                :disabled="loading"
                v-if="props.item.inquiryStatus == 'Customer Rate Accepted'"
                target="_blank"
                class="track-ass-btn m-t-10 m-l-10 orange-button oms-btn oms-btn--conditional"
                title="Recreate Inquiry"
              >
                Recreate Inquiry
              </button>

              <button
                @click="goToProfile(props.item.jobId)"
                v-if="
                  (props.item.jobId &&
                    props.item.inquiryStatus == 'Customer Rate Accepted') ||
                  (props.item.jobId &&
                    props.item.inquiryStatus == 'Low Credit Limit')
                "
                target="_blank"
                class="track-ass-btn m-t-10 m-l-10 oms-btn oms-btn--primary"
                title="Inquiry Details"
              >
                Details
              </button>
            </div>
          </td>
        </template>
        <v-alert
          slot="no-results"
          :value="isNoSearchResult"
          color="blue"
          icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
        <template slot="no-data">
          <div class="sales-empty-state">No data available</div>
        </template>
        </v-data-table>
      </ScrollableTable>
      <ScrollableTable
        v-else
        class="sales-table-scroll oms-list-table-scroll"
        min-width="100%"
      >
        <v-data-table
          id="customerListTable"
          class="sales-modern-table sales-modern-table--pak oms-list-table"
          hide-actions
          :headers="headersPak"
          :items="items"
          :disable-initial-sort="true"
          :pagination.sync="pagination"
        >
        <template slot="items" slot-scope="props">
          <td class="sales-job-cell">
            <div class="sales-job-id-row">
              <activityLogs
                class="sales-row-log-button"
                :type="'inquiry'"
                :id="props.item.inquiryId.toString()"
              />
              <span
                :class="['sales-job-id', salesIdSizeClass(props.item.jobId)]"
                :title="props.item.jobId ? props.item.jobId.toString() : '-'"
              >
                {{ props.item.jobId || "-" }}
              </span>
            </div>
          </td>
          <td class="sales-inquiry-id-cell">
            <span
              :class="[
                'sales-inquiry-id',
                salesIdSizeClass(props.item.inquiryId),
              ]"
              :title="props.item.inquiryId.toString()"
            >
              {{ props.item.inquiryId }}
            </span>
          </td>
          <td class="sales-country-cell">
            <div class="sales-country-content">
              <img
                v-if="props.item.workingCountry == 'PAK'"
                src="../../assets/pakflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'KSA'"
                src="../../assets/ksaflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE'"
                src="../../assets/Uaeflag.png"
                height="20px"
              />
              <img
                v-if="props.item.workingCountry == 'UAE LA'"
                src="../../assets/Uaeflag.png"
                height="20px"
                style="border-radius: 50%"
              />
              <img
                v-if="props.item.workingCountry == 'OMAN'"
                src="../../assets/omanflag.png"
                height="28px"
              />
              <span class="sales-country-label">
                {{ props.item.workingCountry || "-" }}
              </span>
            </div>
          </td>
          <td class="sales-job-type-cell">
            {{ getJobTypeWithCount(props.item.jobType) || "Land" }}
          </td>
          <td v-if="props.item.userId" class="sales-customer-cell">
            <div class="sales-customer-stack sales-customer-stack--compact">
              <div
                :class="[
                  'sales-customer-company',
                  salesTextSizeClass(capitalize(props.item.userId.companyName))
                ]"
                :title="capitalize(props.item.userId.companyName) || 'N.A.'"
              >
                {{ capitalize(props.item.userId.companyName) || "N.A." }}
              </div>
              <CustomerDetailPopUp
                :detail="props.item"
                trigger-class="sales-customer-view-btn"
              />
            </div>
          </td>
          <td v-else>NA</td>
          <td v-if="props.item.bookingDate" class="sales-start-date-cell">
            {{ getTime3(props.item.bookingDate) }}
          </td>
          <td v-else class="sales-start-date-cell">NA</td>
          <td>
            <salesAddressPopup :inquiryId="props.item.inquiryId" />
          </td>
          <td class="sales-trucks-cell">
            <span class="sales-trucks-value">
              {{ props.item.numberOfAssignmentsRequired || "N.A" }}
            </span>
          </td>
          <td>
            {{ $formatPrice(props.item.quotedPrice) }}
            {{ props.item.customerCurrency || "" }} |
            {{ props.item.inquirySource || "N.A." }}
            <!-- <br /><span
              v-if="
                props.item.workingCountry == 'UAE' ||
                props.item.workingCountry == 'KSA'
              "
              >Credit Limit Remain:<span
                v-if="
                  props.item.userId.creditRemaining == 0 ||
                  props.item.userId.creditRemaining < 0
                "
                class="red-text"
                >{{ props.item.userId.creditRemaining }}
                {{ props.item.customerCurrency || "" }}</span
              >
              <span v-else
                >{{ props.item.userId.creditRemaining }}
                {{ props.item.customerCurrency || "" }}</span
              >
            </span> -->
            <br />
            <a v-if="props.item.proof && props.item.proof.length">
              <ProofOfDelivery :deliveryProof="props.item.proof" />
            </a>
          </td>
          <td v-if="props.item.quoteNeededBy">
            {{ getTime4(props.item.quoteNeededBy) }}
          </td>
          <td v-else>NA</td>
          <td class="sales-status-cell">
            <span
              :class="[
                'sales-status-pill',
                statusClass(props.item.inquiryStatus),
                salesTextSizeClass(props.item.inquiryStatus)
              ]"
            >
              {{ props.item.inquiryStatus || "N.A." }}
            </span>
            <div class="sales-cell-actions sales-cell-actions--status">
              <button
                @click="open(props.item, 'Delay', props.index)"
                v-if="
                  props.item.inquiryStatus == 'Inquiry Received' ||
                  props.item.inquiryStatus == 'Reopen'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn yellow-button oms-btn oms-btn--conditional"
                title="Mark as Delayed"
              >
                Delayed
              </button>

              <button
                @click="open(props.item, 'Lead lost', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit'
                "
                target="_blank"
                :loading="loading"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 red-button oms-btn oms-btn--destructive"
                title="Mark as lead lost"
              >
                Lead Lost
              </button>
            </div>
          </td>

          <td v-if="props.item.jobId" class="sales-assignments-cell">
            <Assignments
              v-permissions="'activity-logs-jobs'"
              :jobId="props.item.jobId"
              :Section="'Sales'"
            />
          </td>
          <td v-else class="sales-assignments-cell"></td>

          <td class="sales-actions-cell">
            <div class="sales-cell-actions">
              <button
                @click="check(props.item.inquiryId)"
                v-if="
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Low Credit Limit'
                "
                target="_blank"
                :disabled="
                  props.item.inquiryStatus == 'Low Credit Limit' || loading
                "
                class="track-ass-btn oms-btn oms-btn--secondary"
                title="Edit Inquiry"
                v-permissions="'edit-enquiry'"
              >
                <v-icon color="red darken-1" flat prepend-icon>create</v-icon>
              </button>

              <button
                @click="open(props.item, 'Customer Rate Accepted', props.index)"
                v-if="
                  props.item.inquiryStatus != 'Lead lost' &&
                  props.item.inquiryStatus != 'Customer Rate Accepted' &&
                  props.item.inquiryStatus != 'Low Credit Limit'
                "
                target="_blank"
                :disabled="props.item.inquiryStatus == 'Low Credit Limit'"
                class="track-ass-btn m-t-10 m-l-10 green-button oms-btn oms-btn--primary sales-rate-accepted-btn"
                title="Mark as Rate Accepted"
              >
                Customer Rate Accepted
              </button>

              <button
                v-permissions="'add-enquiry'"
                @click="
                  recreateInquiry(props.item.inquiryId, props.item.userId.userId)
                "
                :disabled="loading"
                v-if="props.item.inquiryStatus == 'Customer Rate Accepted'"
                target="_blank"
                class="track-ass-btn m-t-10 m-l-10 orange-button oms-btn oms-btn--conditional"
                title="Recreate Inquiry"
              >
                Recreate Inquiry
              </button>

              <button
                @click="goToProfile(props.item.jobId)"
                v-if="
                  (props.item.jobId &&
                    props.item.inquiryStatus == 'Customer Rate Accepted') ||
                  (props.item.jobId &&
                    props.item.inquiryStatus == 'Low Credit Limit')
                "
                target="_blank"
                class="track-ass-btn m-t-10 m-l-10 oms-btn oms-btn--primary"
                title="Inquiry Details"
              >
                Details
              </button>
            </div>
          </td>
        </template>
        <v-alert
          slot="no-results"
          :value="isNoSearchResult"
          color="blue"
          icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
        <template slot="no-data">
          <div class="sales-empty-state">No data available</div>
        </template>
        </v-data-table>
      </ScrollableTable>
      <pagination
        class="sales-pagination"
        :totalPages="totalPages"
        :pages="this.pages"
        @pageNo="page"
        :url="listApiUrl"
        :callback="callback"
        :componentKey="componentKey"
        :action="`sales`"
        :payload="payload"
        :type="1"
        v-on:pagination-load="checkLoading"
      />
    </v-card-text>
    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
    <v-snackbar
      :timeout="6000"
      bottom
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
    <v-dialog
      v-model="dialog"
      persistent
      :max-width="options.width"
      content-class="sales-status-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <header class="oms-modal-header">
          <div class="oms-modal-header__brand">
            <div class="oms-modal-header__badge" aria-hidden="true">
              <v-icon>sync_alt</v-icon>
            </div>
            <div class="oms-modal-header__copy">
              <h2 class="oms-modal-header__title">{{ title }}</h2>
            </div>
          </div>
        </header>
        <v-card-text v-show="!!message" class="pa-4">
          {{ message }}
          <v-text-field
            type="text"
            label="Comments"
            required
            v-model="statusComments"
            :value="statusComments"
          />
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn
            color="primary darken-1"
            class="sales-status-dialog__primary"
            :loading="loading"
            text
            @click.native="agree"
            >Yes</v-btn
          >
          <v-btn
            color="grey"
            class="sales-status-dialog__secondary"
            text
            @click.native="cancel"
            :disabled="loading"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
      <!------Low-limit-dialog-------->
    </v-dialog>
    <v-dialog
      v-model="dialog1"
      persistent
      :max-width="options.width"
      content-class="sales-status-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <header class="oms-modal-header">
          <div class="oms-modal-header__brand">
            <div class="oms-modal-header__badge" aria-hidden="true">
              <v-icon>help_outline</v-icon>
            </div>
            <div class="oms-modal-header__copy">
              <h2 class="oms-modal-header__title">Confirmation</h2>
            </div>
          </div>
        </header>
        <v-card-text class="pa-4"
          >Are you sure want accept the customer rate as it is less than your
          credit limit?</v-card-text
        >
        <v-card-actions class="pt-0">
          <v-btn
            color="primary darken-1"
            class="sales-status-dialog__primary"
            :loading="loading"
            text
            @click.native="agreeCredit()"
            >Yes</v-btn
          >
          <v-btn
            color="grey"
            class="sales-status-dialog__secondary"
            text
            @click.native="cancel"
            :disabled="loading"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from "lodash";
import { EventBus } from "../../event-bus.js";
import moment from "moment";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import activityLogs from "../Common/activityLogs";
import Loading from "vue-loading-overlay";
import PaginationButtons from "@/components/Pagination/Pagination-New";
import SuccessDialog from "@/components/Common/SuccessDialog";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import ErrorBox from "@/components/Common/ErrorBox";
import { page } from "vue-analytics";
import { debuglog } from "util";
import pagination from "@/components/Pagination/pagination";
import { StorageKeys } from "../../constants/constants";
import { salesList, salesListPak } from "@/constants/datatable-headers.js";
import { salesSectionApiUrl } from "@/constants/api-urls.js";
import UpdateStatus from "./UpdateStatus";
import salesAddressPopup from "./salesAddressPopup";
import Assignments from "@/components/Procurement/Assignments";
import ScrollableTable from "@/components/Common/ScrollableTable";
import CustomerDetailPopUp from "@/components/Customer/CustomerDetailPopUp";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
      this.track("Sales Section", {
        email: localStorage.getItem("email"),
        name: localStorage.getItem("user"),
        "Working Country": workingCountry.toString(),
      });
      this.payload = {
        workingCountry: this.workingCountry,
      };
    }

    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = val;
      this.$eventBus.$emit("on-load");

      this.getStoredFilters();
    });

    this.$eventBus.$on("close-job-profile", () => {
      this.dialog = false;
      this.currentItem = null;
    });
  },
  components: {
    pagination,
    activityLogs,
    SuccessDialog,
    ProofOfDelivery,
    ErrorBox,
    UpdateStatus,
    Assignments,
    salesAddressPopup,
    ScrollableTable,
    CustomerDetailPopUp,
  },
  props: {
    dashboardData: Function,
    searchText: String,
    searchTextType: String,
    loading: Boolean,
    countryFilter: String,
    convertedInquiry: String,
    reset: Boolean,
    startDateFilter: String,
    jobTypeFilter: String,
    endDateFilter: String,
    executiveFilter: Object,
    inquiryStatus: String,
  },
  watch: {
    pagination(val) {
      if (val["sortBy"] === "source") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "bookingDate";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "bookingDate";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        }
      } else if (val["sortBy"] === "trucks") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "numberOfAssignmentsRequired";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "numberOfAssignmentsRequired";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        }
      } else if (val["sortBy"] === "quote") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "quotations";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "quotations";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.$eventBus.$emit("on-load");
        }
      }

      if (!val["sortBy"]) {
        delete this.payload["sortType"];
        delete this.payload["sortBy"];
        if (val["descending"] == null) {
          this.componentKey = this.componentKey + 1;
        }
        this.$eventBus.$emit("on-load");
      }
      deep: true;
    },
    searchTextType: function (n, o) {
      if (n && n.trim() != "") {
        this.$set(this.payload, "searchType", n);
        delete this.payload.searchText;
      }
    },
    convertedInquiry: function (n, o) {
      if (n && n.trim() != "") {
        this.$set(this.payload, "isConvertedInquiry", n);
      }
    },

    searchText: function (n, o) {
      if (n.trim() != "") {
        this.$emit("off-load", false);
        this.payload.searchType = this.searchTextType;
        this.$eventBus.$emit("on-load");
        this.$set(this.payload, "searchText", n);
      } else {
        if (this.searchTextType) {
          this.$set(this.payload, "searchType", this.searchTextType);
          delete this.payload.searchText;
          this.componentKey++;
        }
      }
    },

    inquiryStatus: function (n, o) {
      if (n != "" && n) {
        this.$emit("off-load", false);
        this.$set(this.payload, "inquiryStatus", n);
      }
    },

    jobTypeFilter: function (n, o) {
      if (n != "") {
        this.$emit("off-load", false);
        this.jobTypeFilterValue = n;
        this.$set(this.payload, "jobType", n);
      }
    },
    executiveFilter: function (n, o) {
      if (n.salesExecutive && n.salesExecutive.length) {
        this.executiveFilterValue = n.salesExecutive;
        this.$set(this.payload, "salesExecutive", n.salesExecutive);
        this.payload.allSalesExecutive = n.allSalesExecutive;
      } else if (!n.salesExecutive.length) {
        if (this.payload.salesExecutive || this.payload.allSalesExecutive) {
          delete this.payload.salesExecutive;
          delete this.payload.allSalesExecutive;
          this.componentKey++;
        }
      }
    },
    reset: function (n, o) {
      this.$emit("off-load", false);

      if (n) {
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    startDateFilter: function (n, o) {
      if (n != "") {
        this.startDateFilterValue = n;
        this.$set(this.payload, "startDate", n);
      } else {
        this.startDateFilterValue = "";
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    endDateFilter: function (n, o) {
      if (n != "") {
        this.endDateFilterValue = n;
        this.$set(this.payload, "endDate", n);
      } else {
        this.endDateFilterValue = "";
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    deep: true,
    immediate: true,
  },
  data() {
    return {
      operation: "",
      listApiUrl: salesSectionApiUrl.inquiryList,
      operatioName: "",
      workingCountry: null,
      title: null,
      dialog1: false,
      messagePending: null,
      message: null,
      dialog: false,
      pagination: {},
      statusComments: "",
      options: {
        color: "#ffc04c",
        width: 360,
        zIndex: 200,
      },
      currentEnquiry: null,
      currentStatus: null,
      currentIndex: null,
      processing: false,
      componentKey: 0,
      executiveFilterValue: "",
      endDateFilterValue: "",
      jobTypeFilterValue: "",
      startDateFilterValue: "",
      searchTextValue: "",
      search: "",
      isNoSearchResult: false,
      payload: {},
      pages: 1,
      totalPages: 0,
      x: {
        message: "",
        loading: true,
        success: false,
        menu: false,
        dateOfBirth: null,
        error: null,
        missingField: null,
      },
      headers: salesList,
      headersPak: salesListPak,
      documentData: [],
      items: [],
    };
  },
  methods: {
    salesIdSizeClass(value) {
      const length = value ? value.toString().length : 1;

      if (length >= 11) {
        return "sales-id--micro";
      }

      if (length >= 9) {
        return "sales-id--tight";
      }

      if (length >= 7) {
        return "sales-id--compact";
      }

      return "";
    },
    salesTextSizeClass(value) {
      const length = value ? value.toString().trim().length : 0;

      if (length >= 42) {
        return "sales-text--xs";
      }

      if (length >= 32) {
        return "sales-text--sm";
      }

      if (length >= 20) {
        return "sales-text--md";
      }

      return "";
    },
    getStoredFilters() {
      if (localStorage.getItem("payloadSales") !== null) {
        this.payload.workingCountry = this.workingCountry;
      }
      if (!localStorage.getItem("payloadSales")) {
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    checkLoading(event) {
      if (event) {
        this.$emit("on-load", true);
      } else {
        // this.$emit("job-load", false);
        this.$emit("off-load", false);
      }
    },
    recreateInquiry(id, userId) {
      // this.loading = true;
      let url = salesSectionApiUrl.checkRecreateInquiry;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        userId: userId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.status === 200) {
            localStorage.setItem(
              "current-enquiry-page-status",
              JSON.stringify(this.payload)
            );
            this.$router.push(`/inquiry/recreate/${id}`);
            //this.loading = false;
          }
        },
        (error) => {
          // this.loading = false;
          this.x.error = error.response.data.message;
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
        }
      );
    },
    async check(id) {
      this.operationName = "edit-enquiry";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y) {
        localStorage.setItem(
          "current-enquiry-page-status",
          JSON.stringify(this.payload)
        );
        this.$router.push(`/inquiry/edit/${id}`);
      } else {
        return;
      }
    },
    goToProfile(jobId) {
      this.$eventBus.$emit("view-details", true);
      this.$router.push(`/jobs/${jobId}/view`);
    },
    page(event) {
      this.pages = event;
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },
    getJobTypeWithCount(type) {
      var stringAir = "";
      var stringSea = "";
      var stringLand = "";
      if (type) {
        var count = {};
        var string = "";
        type.forEach(function (i) {
          count[i] = (count[i] || 0) + 1;
        });
        if (count["2"] > 0) {
          stringAir = " Air-" + count["2"];
        }
        if (count["3"] > 0) {
          stringSea = " Sea-" + count["3"];
        }
        if (count["1"] > 0) {
          stringLand = " Land-" + count["1"];
        }
        if (stringAir.length > 0 || stringSea.length > 0) {
          stringLand = stringLand.length > 0 ? stringLand + "," : stringLand;
        }
        if (stringSea.length > 0) {
          stringAir = stringAir.length > 0 ? stringAir + "," : stringAir;
        }
        return stringLand + stringAir + stringSea;
      } else {
        return "Land-1";
      }
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    statusClass(status) {
      switch (status) {
        case "Customer Rate Accepted":
          return "sales-status-pill--accepted";
        case "Lead lost":
          return "sales-status-pill--lost";
        case "Low Credit Limit":
          return "sales-status-pill--credit";
        case "Delay":
        case "Delayed":
          return "sales-status-pill--delayed";
        case "Reopen":
          return "sales-status-pill--reopen";
        case "Inquiry Received":
          return "sales-status-pill--received";
        default:
          return "sales-status-pill--default";
      }
    },
    open(val, type, index) {
      this.currentStatus = type;
      this.currentEnquiry = val;
      this.currentIndex = index;
      this.statusComments = "";
      this.dialog = true;
      this.title = "Change Inquiry's Status";
      this.message = "Click Yes to update inquiry's status";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      if (this.statusComments.trim()) {
        if (
          this.currentStatus == "Delay" ||
          this.currentStatus == "Lead lost"
        ) {
          this.updateStatus(this.currentEnquiry, this.currentStatus);
        }
        if (this.currentStatus == "Customer Rate Accepted") {
          this.checkStatus(this.currentEnquiry, this.currentStatus);
        }
      } else {
        this.x.error = "Please provide comments before moving ahead";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.dialog1 = false;
    },
    agreeCredit() {
      this.resolve(true);
      if (this.statusComments.trim()) {
        this.updateStatus(this.currentEnquiry, this.currentStatus);
      } else {
        this.x.error = "Please provide comments before moving ahead";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
    },
    checkStatus(value, status) {
      this.currentStatus = status;
      this.currentEnquiry = value;
      //  this.loading = true;
      let url = salesSectionApiUrl.checkCreditLimit;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        inquiryId: value._id,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.status === 200) {
            page("/sales/" + status + "?user=" + localStorage.getItem("user"));
            this.updateStatus(this.currentEnquiry, this.currentStatus);
            this.componentKey += 1;
            this.dialog = false;
            // this.loading = false;
          }
        },
        (error) => {
          // this.loading = false;
          if (error.response.data.statusCode === 400) {
            this.x.error = error.response.data.message;
          }
          if (error.response.data.statusCode === 402) {
            this.x.error = error.response.data.message;
            this.dialog1 = true;
            this.dialog = false;
          } else {
            this.x.error = error.response.data.message;
          }
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
        }
      );
    },
    updateStatus(value, status) {
      //this.loading = true;
      let url = salesSectionApiUrl.changeStatus;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        inquiryId: value._id,
        inquiryStatus: status,
      };
      if (this.statusComments) {
        body.comments = this.statusComments.trim();
      }
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.status === 200) {
            this.dialog1 = false;
            this.dialog = false;
            this.identify(localStorage.getItem("email"));
            if (status == "Lead lost") {
              this.track("Lead lost", {
                "Inquiry Id": value.inquiryId || "N.A",
                "Company Name/Customer Name":
                  value.userId.companyName ||
                  value.userId.customer ||
                  value.userId.customerEmail ||
                  "N.A",
                "No. of assignmnets":
                  value.numberOfAssignmentsRequired || "N.A",
                "Job Start Date": value.bookingDateTime || "N.A",
                "Working Country": value.workingCountry || "N.A",
                "Selling Price": value.quotedPrice || "N.A",
                Status: status,
              });
            }
            if (status == "Delay") {
              this.track("Delay Inquiry", {
                "Inquiry Id": value.inquiryId || "N.A",
                "Company Name/Customer Name":
                  value.userId.companyName ||
                  value.userId.customer ||
                  value.userId.customerEmail ||
                  "N.A",
                "No. of assignmnets":
                  value.numberOfAssignmentsRequired || "N.A",
                "Job Start Date": value.bookingDateTime || "N.A",
                "Working Country": value.workingCountry || "N.A",
                "Selling Price": value.quotedPrice || "N.A",
              });
            }
            if (status == "Customer Rate Accepted") {
              this.track("Customer Rate Accepted", {
                "Inquiry Id": value.inquiryId || "N.A",
                "Company Name/Customer Name":
                  value.userId.companyName ||
                  value.userId.customer ||
                  value.userId.customerEmail,
                "No. of assignmnets":
                  value.numberOfAssignmentsRequired || "N.A",
                "Job Start Date": value.bookingDateTime || "N.A",
                "Working Country": value.workingCountry || "N.A",
                "Selling Price": value.quotedPrice || "N.A",
              });
            }
            this.componentKey += 1;
            //  this.loading = false;
          }
        },
        (error) => {
          // this.loading = false;
          this.x.error = error.response.data.message;
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
        }
      );
    },
    // paginationPayload(event) {
    //   this.loading = event;
    //   this.payload = event;
    //   localStorage.removeItem("current-enquiry-page-status");
    // },
    openDocument(data) {
      this.getCustomer(data.userId);
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.$emit("on-block");
    },

    editEnquiry(id) {
      localStorage.setItem(
        "current-enquiry-page-status",
        JSON.stringify(this.payload)
      );
      this.$router.push(`/inquiry/edit/${id}`);
    },

    getTime(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    callback(res) {
      //localStorage.setItem("payloadSales", JSON.stringify(this.payload));
      this.items = [...res.list];
      this.totalPages = Math.ceil(res.totalData / 15);
      this.pagination.rowsPerPage = 15;
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].createdOn = moment(
          String(this.items[i].registrationDate)
        ).format("MM/DD/YYYY hh:mm A");
      }
      this.dashboardData(res);
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
#customerListTable .theme--light.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
  color: white !important;
  margin-left: 10px !important;
}
#customerListTable
  .theme--light.v-datatable
  thead
  th.column.sortable.active
  .v-icon {
  opacity: 1 !important;
  color: white !important;
  margin-left: 10px !important;
}
.card--raised {
  border: 1px solid #ea7a1c !important;
}

#customerListTable td {
  padding: 0.5rem !important;
  font-size: 0.8125rem !important;
}

.sales-status-dialog,
.sales-status-dialog.v-dialog,
.sales-status-dialog .v-dialog {
  max-width: 24rem !important;
  width: calc(100vw - 2rem) !important;
}

.sales-status-dialog .v-card,
.sales-status-dialog.v-dialog .v-card {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.875rem !important;
  box-shadow: 0 1.25rem 2.75rem rgba(26, 25, 22, 0.18) !important;
  overflow: hidden;
  padding: 0 !important;
}

.sales-status-dialog .v-card__text,
.sales-status-dialog.v-dialog .v-card__text {
  color: var(--oms-ink, #3a382f);
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.8125rem;
  line-height: 1.45;
  padding: 1rem 1.125rem 0.875rem !important;
}

.sales-status-dialog .v-text-field,
.sales-status-dialog.v-dialog .v-text-field {
  margin-top: 0.875rem !important;
  padding-top: 0 !important;
}

.sales-status-dialog .v-text-field .v-input__slot,
.sales-status-dialog.v-dialog .v-text-field .v-input__slot {
  border-bottom: 0.0625rem solid var(--oms-control-border, #d8d3ca) !important;
}

.sales-status-dialog .v-label,
.sales-status-dialog.v-dialog .v-label {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.8125rem !important;
}

.sales-status-dialog .v-text-field .v-input__slot:after,
.sales-status-dialog.v-dialog .v-text-field .v-input__slot:after {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.sales-status-dialog .v-card__actions,
.sales-status-dialog.v-dialog .v-card__actions {
  background: var(--oms-surface-soft, #faf9f6);
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.75rem 1rem !important;
}

.sales-status-dialog .v-card__actions .v-btn,
.sales-status-dialog.v-dialog .v-card__actions .v-btn {
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: 2.375rem !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 5rem !important;
  padding: 0 0.875rem !important;
  text-transform: none !important;
}

.sales-status-dialog__primary.v-btn,
.sales-status-dialog .sales-status-dialog__primary.v-btn,
.sales-status-dialog.v-dialog .sales-status-dialog__primary.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  border: 0.0625rem solid var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.sales-status-dialog__secondary.v-btn,
.sales-status-dialog .sales-status-dialog__secondary.v-btn,
.sales-status-dialog.v-dialog .sales-status-dialog__secondary.v-btn {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #d8d3ca) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.sales-status-dialog__primary.v-btn:hover,
.sales-status-dialog .sales-status-dialog__primary.v-btn:hover,
.sales-status-dialog.v-dialog .sales-status-dialog__primary.v-btn:hover {
  background: var(--oms-primary-dark, #d96a10) !important;
  border-color: var(--oms-primary-dark, #d96a10) !important;
}

.sales-status-dialog__secondary.v-btn:hover,
.sales-status-dialog .sales-status-dialog__secondary.v-btn:hover,
.sales-status-dialog.v-dialog .sales-status-dialog__secondary.v-btn:hover {
  border-color: var(--oms-border-strong, #d2cec3) !important;
  color: var(--oms-ink-strong, #1a1916) !important;
}

.sales-status-dialog__primary.v-btn .v-btn__content,
.sales-status-dialog__secondary.v-btn .v-btn__content {
  color: inherit !important;
}

html.oms-night-mode #nav .sales-customer-stack ::v-deep .sales-customer-view-btn {
  background: rgba(245, 130, 32, 0.12) !important;
  border-color: #f58220 !important;
  color: #f8bd82 !important;
}

html.oms-night-mode #nav .sales-customer-stack ::v-deep .sales-customer-view-btn:hover,
html.oms-night-mode #nav .sales-customer-stack ::v-deep .sales-customer-view-btn:focus {
  background: #f58220 !important;
  border-color: #f58220 !important;
  color: #ffffff !important;
}

#nav .sales-modern-table table.v-table thead th.sales-assignments-header,
#nav .sales-modern-table table.v-table thead th.sales-actions-header {
  box-sizing: border-box;
  font-size: 0.625rem !important;
  letter-spacing: 0 !important;
  line-height: 1.1 !important;
  overflow: hidden !important;
  overflow-wrap: normal !important;
  text-align: center !important;
  text-transform: uppercase;
  white-space: nowrap !important;
  word-break: keep-all !important;
}

#nav .sales-modern-table table.v-table thead th.sales-assignments-header {
  padding-left: 0.125rem !important;
  padding-right: 0.625rem !important;
}

#nav .sales-modern-table table.v-table thead th.sales-actions-header {
  box-shadow: inset 0.0625rem 0 0 #fed7aa;
  padding-left: 0.625rem !important;
  padding-right: 0.125rem !important;
}

#nav .sales-modern-table table.v-table thead th.sales-assignments-header > span,
#nav .sales-modern-table table.v-table thead th.sales-assignments-header > div,
#nav .sales-modern-table table.v-table thead th.sales-actions-header > span,
#nav .sales-modern-table table.v-table thead th.sales-actions-header > div {
  display: inline-flex !important;
  justify-content: center !important;
  max-width: 100%;
  min-width: 0;
  overflow: hidden !important;
  white-space: nowrap !important;
}

</style>

<style scoped>
.sales-table-scroll {
  max-width: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.sales-list-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  margin: 0 var(--oms-list-section-x, 1.75rem) 1.5rem !important;
  padding: 0 !important;
}

.sales-list-card > .v-card__text,
.sales-list-body {
  padding: 0 !important;
}

.sales-list-card .note-text {
  display: block;
  padding: 0 0 0.5rem;
}

.sales-modern-table ::v-deep .v-table__overflow {
  background: #f8fafc;
  border: 0.0625rem solid #e4e8f0;
  border-radius: 0.5rem;
  overflow-x: hidden !important;
  width: 100%;
}

.sales-modern-table ::v-deep table.v-table thead th.table-header-item {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  color: #9a4f08 !important;
  font-weight: 800 !important;
  line-height: 1.2 !important;
  padding: 0.5rem 0.375rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: normal !important;
}

.sales-modern-table ::v-deep table.v-table thead th.sales-assignments-header,
.sales-modern-table ::v-deep table.v-table thead th.sales-assignments-header > span,
.sales-modern-table ::v-deep table.v-table thead th.sales-assignments-header > div,
.sales-modern-table ::v-deep table.v-table thead th.sales-actions-header,
.sales-modern-table ::v-deep table.v-table thead th.sales-actions-header > span,
.sales-modern-table ::v-deep table.v-table thead th.sales-actions-header > div {
  overflow-wrap: normal !important;
  white-space: nowrap !important;
  word-break: keep-all !important;
}

.sales-modern-table ::v-deep table.v-table thead th.table-header-item > span,
.sales-modern-table ::v-deep table.v-table thead th.table-header-item > div {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100%;
  text-align: center;
  width: 100%;
}

.sales-modern-table ::v-deep table.v-table tbody td[colspan] {
  color: #64748b !important;
  font-size: 0.875rem !important;
  font-weight: 800;
  height: 5rem;
  text-align: center !important;
}

.sales-modern-table ::v-deep table.v-table {
  background: transparent !important;
  border-collapse: separate;
  border-spacing: 0 0.5rem;
  min-width: 100% !important;
  table-layout: fixed;
  width: 100%;
}

.sales-modern-table ::v-deep table.v-table tbody tr {
  background: transparent !important;
  box-shadow: none;
}

.sales-modern-table ::v-deep table.v-table tbody td {
  background: #ffffff;
  border-bottom: 0.0625rem solid #e7ecf3 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0.0625rem solid #e7ecf3 !important;
  box-sizing: border-box;
  color: #2e3748;
  font-size: 0.8125rem !important;
  line-height: 1.35;
  overflow-wrap: break-word;
  padding: 0.5rem !important;
  text-align: left !important;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
}

.sales-modern-table ::v-deep table.v-table tbody td {
  text-align: center !important;
}

.sales-modern-table ::v-deep table.v-table tbody td:first-child {
  border-left: 0.25rem solid #f58220 !important;
  border-radius: 0.625rem 0 0 0.625rem !important;
  color: #b95d07;
  font-weight: 800;
  padding-left: 0.5rem !important;
}

.sales-modern-table ::v-deep table.v-table tbody td:last-child {
  border-radius: 0 0.625rem 0.625rem 0 !important;
  border-right: 0.0625rem solid #eef1f5 !important;
}

.sales-modern-table ::v-deep table.v-table tbody tr:hover td {
  background: #fbfdff !important;
}

.sales-job-cell {
  max-width: 0;
  overflow: hidden !important;
  padding-left: 0.5rem !important;
  padding-right: 0.375rem !important;
  position: relative;
  white-space: nowrap !important;
}

.sales-job-id-row {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
  justify-content: flex-start;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  padding-left: 0;
  position: relative;
  width: 100%;
}

.sales-job-id-row > div,
.sales-job-id-row .v-btn,
.sales-job-id-row button {
  flex: 0 0 auto;
  height: 1.25rem !important;
  margin: 0 !important;
  min-width: 1.25rem !important;
  padding: 0 !important;
  width: 1.25rem !important;
}

.sales-job-id-row .v-icon {
  font-size: 0.875rem !important;
  height: 0.875rem !important;
  line-height: 0.875rem !important;
  width: 0.875rem !important;
}

.sales-modern-table ::v-deep .sales-job-id-row > .sales-row-log-button.activity-log-trigger,
.sales-job-id-row > .sales-row-log-button {
  align-items: center;
  background: #fff7ed !important;
  border: 0.0625rem solid #fdba74 !important;
  border-radius: 999rem;
  box-shadow: none;
  box-sizing: border-box;
  color: #ea580c !important;
  cursor: pointer;
  display: inline-flex !important;
  flex: 0 0 1.5rem !important;
  height: 1.5rem !important;
  justify-content: center;
  margin: 0 !important;
  min-height: 1.5rem !important;
  min-width: 1.5rem !important;
  padding: 0 !important;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    color 0.16s ease;
  width: 1.5rem !important;
}

.sales-modern-table ::v-deep .sales-job-id-row > .sales-row-log-button.activity-log-trigger:hover,
.sales-modern-table ::v-deep .sales-job-id-row > .sales-row-log-button.activity-log-trigger:focus-within,
.sales-job-id-row > .sales-row-log-button:hover,
.sales-job-id-row > .sales-row-log-button:focus-within {
  background: #f58220 !important;
  border-color: #f58220 !important;
  box-shadow: 0 0.125rem 0.5rem rgba(245, 130, 32, 0.24) !important;
  color: #ffffff !important;
}

.sales-modern-table ::v-deep .sales-job-id-row > .sales-row-log-button.activity-log-trigger .activity-log-trigger__icon.v-icon,
.sales-modern-table ::v-deep .sales-job-id-row > .sales-row-log-button.activity-log-trigger .v-icon,
.sales-job-id-row > .sales-row-log-button ::v-deep .v-icon {
  align-items: center !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  box-sizing: border-box;
  color: currentColor !important;
  display: inline-flex;
  flex: 0 0 1.5rem !important;
  font-size: 0.9375rem !important;
  height: 1.5rem !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 1.5rem !important;
  min-width: 1.5rem !important;
  opacity: 1 !important;
  padding: 0 !important;
  text-align: center;
  -webkit-text-fill-color: currentColor !important;
  width: 1.5rem !important;
}

.sales-job-id,
.sales-inquiry-id {
  color: #0f172a;
  display: block;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.12;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-id--compact {
  font-size: 0.65625rem !important;
  letter-spacing: -0.02em;
}

.sales-id--tight {
  font-size: 0.59375rem !important;
  letter-spacing: -0.03em;
}

.sales-id--micro {
  font-size: 0.53125rem !important;
  letter-spacing: -0.04em;
}

.sales-job-id {
  flex: 1 1 0;
  margin-right: 0;
  min-width: 0;
}

.sales-inquiry-id-cell,
.sales-country-cell,
.sales-job-type-cell,
.sales-trucks-cell {
  text-align: center !important;
}

.sales-inquiry-id-cell {
  max-width: 0;
  overflow: hidden !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  position: relative;
  white-space: nowrap !important;
}

.sales-inquiry-id {
  margin: 0 auto;
  max-width: 100%;
  vertical-align: middle;
}

.sales-country-cell,
.sales-job-type-cell,
.sales-trucks-cell {
  color: #475569 !important;
  font-size: 0.75rem !important;
  font-weight: 800;
  line-height: 1.15;
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  white-space: nowrap !important;
}

.sales-trucks-cell {
  padding-left: 0.125rem !important;
  padding-right: 0.125rem !important;
}

#customerListTable.sales-modern-table ::v-deep table.v-table tbody td.sales-trucks-cell,
.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(8),
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(8) {
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.sales-trucks-value {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  margin: 0 auto;
  min-width: 100%;
  text-align: center;
  width: 100%;
}

.sales-country-cell img {
  border-radius: 999rem;
  box-shadow: 0 0 0 0.0625rem #e2e8f0;
  height: 1.25rem !important;
  margin: 0;
  object-fit: cover;
  width: 1.75rem;
}

.sales-country-content {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 0.1875rem;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
  vertical-align: middle;
  width: 100%;
}

.sales-country-label {
  display: block;
  line-height: 1;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: clip;
  white-space: nowrap;
}

.sales-customer-cell {
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  padding-bottom: 0.45rem !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  padding-top: 0.45rem !important;
  word-break: normal !important;
  text-align: left !important;
}

.sales-customer-stack {
  display: grid;
  gap: 0.1875rem;
  line-height: 1.24;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  width: 100%;
}

.sales-customer-company {
  color: #0f172a;
  display: block;
  font-size: 0.75rem;
  font-weight: 800;
  hyphens: none;
  overflow: visible;
  overflow-wrap: break-word;
  text-overflow: clip;
  white-space: normal;
  word-break: normal !important;
}

.sales-text--md {
  font-size: 0.6875rem !important;
  line-height: 1.16 !important;
}

.sales-text--sm {
  font-size: 0.625rem !important;
  line-height: 1.12 !important;
}

.sales-text--xs {
  font-size: 0.5625rem !important;
  line-height: 1.1 !important;
}

.sales-customer-stack--compact {
  align-items: center;
  gap: 0.5rem;
  justify-items: center;
  min-height: 3.25rem;
}

.sales-customer-stack--compact .sales-customer-company {
  text-align: center;
}

.sales-customer-stack ::v-deep .sales-customer-view-btn {
  align-items: center;
  background: #fff7ed !important;
  border: 0.0625rem solid #f58220 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #c2410c !important;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 1;
  min-height: 1.75rem;
  min-width: 3.5rem;
  padding: 0.25rem 0.75rem !important;
  text-align: center;
  text-transform: none;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    color 0.16s ease;
  white-space: nowrap;
}

.sales-customer-stack ::v-deep .sales-customer-view-btn:hover,
.sales-customer-stack ::v-deep .sales-customer-view-btn:focus {
  background: #f58220 !important;
  border-color: #f58220 !important;
  color: #ffffff !important;
  outline: none;
}

.sales-customer-row {
  align-items: start;
  display: grid;
  gap: 0.25rem;
  grid-template-columns: 3.25rem minmax(0, 1fr);
  min-width: 0;
  overflow: visible;
  width: 100%;
}

.sales-customer-label {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-customer-value {
  color: #334155;
  display: block;
  font-size: 0.6875rem;
  font-weight: 700;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  overflow-wrap: anywhere;
  text-overflow: clip;
  white-space: normal;
  word-break: normal !important;
}

.sales-customer-value span {
  display: block;
  overflow: visible;
  overflow-wrap: anywhere;
  text-overflow: clip;
  white-space: normal;
}

.sales-customer-value--accent {
  color: #c2410c;
}

.sales-start-date-cell {
  color: #334155 !important;
  font-size: 0.75rem !important;
  font-weight: 800;
  line-height: 1.2;
  overflow: hidden !important;
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  text-align: center !important;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  word-break: normal !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(1),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(1) {
  min-width: 7.5rem;
  width: 9.5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(2),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(2) {
  min-width: 5.5rem;
  width: 7% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(3),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(3) {
  width: 5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(4),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(4) {
  width: 5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(5),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(5) {
  width: 13.25% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(6),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(6) {
  width: 6.5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(7),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(7) {
  width: 4.5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(9),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(9) {
  width: 6% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(8),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(8) {
  width: 2.2% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(10),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(10) {
  width: 8.5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(11),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(11) {
  width: 7% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(12),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(12) {
  width: 9% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(13),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(13) {
  width: 6.5% !important;
}

.sales-modern-table--global ::v-deep table.v-table th:nth-child(14),
.sales-modern-table--global ::v-deep table.v-table td:nth-child(14) {
  text-align: center !important;
  width: 11.35% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(1),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(1) {
  min-width: 7.5rem;
  width: 9.5% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(2),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(2) {
  min-width: 5.5rem;
  width: 7% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(8),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(8) {
  width: 3.6% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(3),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(3) {
  width: 5.75% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(4),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(4) {
  width: 5.75% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(5),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(5) {
  width: 13.25% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(6),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(6) {
  width: 6.5% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(7),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(7) {
  width: 5% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(10),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(10) {
  width: 8% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(9),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(9) {
  width: 10% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(11),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(11) {
  width: 9% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(12),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(12) {
  width: 6.5% !important;
}

.sales-modern-table--pak ::v-deep table.v-table th:nth-child(13),
.sales-modern-table--pak ::v-deep table.v-table td:nth-child(13) {
  text-align: center !important;
  width: 11.1% !important;
}

.sales-assignments-cell {
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.sales-modern-table ::v-deep .sales-assignments-cell > .log {
  align-items: center !important;
  display: inline-flex !important;
  justify-content: center !important;
  margin: 0 auto !important;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.sales-modern-table ::v-deep .sales-assignments-cell .view-ass-btn {
  display: inline-flex !important;
  justify-content: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.sales-trucks-cell,
.sales-trucks-value {
  text-align: center !important;
}

.sales-status-cell,
.sales-actions-cell {
  overflow: hidden !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  text-align: center !important;
}

.sales-status-pill {
  align-items: center;
  border: 0.0625rem solid #e2e8f0;
  border-radius: 999rem;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  justify-content: center;
  line-height: 1.15;
  margin: 0 auto 0.375rem;
  max-width: 7rem;
  min-width: 0;
  min-height: 1.625rem;
  overflow-wrap: normal;
  padding: 0.25rem 0.5rem;
  text-align: center;
  white-space: normal;
  word-break: normal;
  width: 100%;
}

.sales-status-pill--accepted {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #166534;
}

.sales-status-pill--lost,
.sales-status-pill--credit {
  background: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
}

.sales-status-pill--delayed {
  background: #fef3c7;
  border-color: #fde68a;
  color: #92400e;
}

.sales-status-pill--reopen {
  background: #dbeafe;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.sales-status-pill--received,
.sales-status-pill--default {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #334155;
}

.sales-cell-actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.375rem;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.sales-status-cell .sales-cell-actions,
.sales-actions-cell .sales-cell-actions {
  align-items: stretch;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-left: auto;
  margin-right: auto;
}

.sales-status-cell .sales-cell-actions {
  max-width: 7rem;
}

.sales-actions-cell .sales-cell-actions {
  max-width: 9.5rem;
}

.sales-empty-state {
  align-items: center;
  display: flex;
  justify-content: center;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 800;
  min-height: 6rem;
  text-align: center;
  width: 100%;
}

.sales-modern-table ::v-deep .track-ass-btn {
  align-items: center !important;
  background: #f58220 !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.3125rem 0.75rem rgba(245, 130, 32, 0.22) !important;
  color: #ffffff !important;
  display: inline-flex !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  justify-content: center;
  height: auto !important;
  line-height: 1.15 !important;
  margin: 0 !important;
  min-height: 2.25rem !important;
  max-width: 100%;
  min-width: 0 !important;
  padding: 0.5rem 0.875rem !important;
  text-decoration: none !important;
  text-align: center !important;
  overflow-wrap: normal;
  white-space: normal !important;
  width: auto;
  word-break: normal !important;
}

#nav .sales-modern-table ::v-deep .sales-actions-cell .track-ass-btn {
  height: auto !important;
  min-height: 2.25rem !important;
  overflow: visible !important;
}

#nav .sales-modern-table ::v-deep .sales-actions-cell .sales-rate-accepted-btn {
  font-size: 0.5625rem !important;
  line-height: 1.15 !important;
  min-height: 2.75rem !important;
  overflow-wrap: normal !important;
  padding-bottom: 0.375rem !important;
  padding-top: 0.375rem !important;
  white-space: normal !important;
  word-break: normal !important;
}

.sales-modern-table ::v-deep .track-ass-btn:last-child {
  margin-bottom: 0 !important;
}

.sales-modern-table ::v-deep .track-ass-btn[title="Edit Inquiry"] {
  align-self: center;
  flex: 0 0 auto;
  max-width: 2.5rem !important;
  padding: 0.5rem !important;
  width: 2.5rem !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(12),
.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(14),
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(11),
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(13) {
  text-align: center !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(12),
.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(14),
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(11),
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(13) {
  vertical-align: middle !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(12) > button,
.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(14) > button,
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(11) > button,
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(13) > button {
  display: flex !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(12) .track-ass-btn,
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(11) .track-ass-btn {
  max-width: 100% !important;
  min-width: 0 !important;
  width: 100% !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(14) .track-ass-btn,
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(13) .track-ass-btn {
  flex: 0 1 auto;
  max-width: 100% !important;
  min-width: 0 !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  width: 100% !important;
}

.sales-modern-table--global ::v-deep table.v-table tbody td:nth-child(14) .track-ass-btn[title="Edit Inquiry"],
.sales-modern-table--pak ::v-deep table.v-table tbody td:nth-child(13) .track-ass-btn[title="Edit Inquiry"] {
  flex: 0 0 2.5rem;
  min-width: 2.5rem !important;
  width: 2.5rem !important;
}

.sales-modern-table ::v-deep .green-button {
  background: #16a34a !important;
}

.sales-modern-table ::v-deep .red-button {
  background: #dc2626 !important;
}

.sales-modern-table ::v-deep .yellow-button {
  background: #f59e0b !important;
}

.sales-modern-table ::v-deep .orange-button {
  background: #f58220 !important;
}

.sales-modern-table ::v-deep .track-ass-btn[disabled] {
  background: #e2e8f0 !important;
  box-shadow: none !important;
  color: #94a3b8 !important;
  cursor: not-allowed;
}

.sales-pagination {
  background: #ffffff;
  border: 0.0625rem solid #e4e8f0;
  border-radius: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.625rem !important;
}

.sales-pagination ::v-deep .pagination_wrapper {
  padding: 0 !important;
}

.sales-pagination ::v-deep .v-pagination {
  align-items: center;
  gap: 0.25rem;
}

.sales-pagination ::v-deep .v-pagination__item,
.sales-pagination ::v-deep .v-pagination__navigation {
  border-radius: 0.375rem !important;
  height: 2rem !important;
  margin: 0 0.125rem !important;
  min-width: 2rem !important;
}

.customer-actions {
  padding: 0;
  margin: auto 20px auto 0px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.document {
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  color: #666666;
}
.editCustomer {
  margin: auto 0;
}
.v-card {
  padding: 15px;
}
.page-count-span {
  float: right;
  margin-top: 26px;
  color: #ea7a1c;
}
.m-t-10 {
  margin-top: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.v-dialog {
  max-width: 400px !important;
}
.v-dialog .v-card {
  padding: 0 !important;
}
.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
}
.red-text {
  color: red;

  animation: animate 1.5s linear infinite;
}
</style>
